export default __webpack_public_path__ + "static/media/91.54b084be.png";